import { z } from 'zod';

import { UserRole } from '@/entities/user-role';

import { SiteSchema } from './site';

export const RoleSchema = z.object({
  id: z.string(),
  name: z.string(),
  permission: z.nativeEnum(UserRole),
  sites: z
    .array(SiteSchema.pick({ id: true, fullFrontendId: true }))
    .nullable(),
  userCount: z.number(),
});

export type Role = z.infer<typeof RoleSchema>;
